//Add a Dashboard PowerBI report view ID to display its pages.
export default Object.freeze({
  RevisionPeiCentro: 13,
  RLV: 19,
  ConstitucionCompu: 24,
})
